import Vue from 'vue'
import Router from 'vue-router'
import Listing from '../views/Listing.vue'
import Detail from '../views/Detail.vue'

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			name: 'listing',
			component: Listing
		},
		{
			path: '/detail',
			name: 'detail',
			alias: '/detail/*',
			component: Detail
		},
		{
			path: '*',
			redirect: '/'
		}
	],
	scrollBehavior(to, from) {
		if (to.name != from.name) {
			setTimeout(() => window.scrollTo(0, 0), 250)
		}
	}
})
